// Bangalore launch list pop-up: timed auto-open, every #flippd-launch link opens it,
// closes with ✕ / Esc / a tap outside, plus the pincode check and customer tags.
(() => {
  // Auto-open at whichever comes first: 7s on the page or scrolling 30% down.
  const AUTO_OPEN_AFTER = 7000;
  const SCROLL_SHARE = 0.3;
  const SNOOZE_DAYS = 3;                 // after someone closes it
  const KEY_CLOSED = 'flippd-launch-closed-at';
  const KEY_JOINED = 'flippd-launch-joined';
  const store = {
    get: k => { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  const ready = fn => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
  ready(() => {
    const dialog = document.getElementById('flippd-launch');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = '1';
    const form = dialog.querySelector('#FlippdLaunchList');

    const open = () => {
      if (dialog.open) return;
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.classList.add('flippd-launch-is-open');
    };
    const close = () => {
      if (dialog.open) dialog.close(); else dialog.removeAttribute('open');
    };
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('flippd-launch-is-open');
      store.set(KEY_CLOSED, String(Date.now()));
      if (location.hash === '#flippd-launch' || location.hash === '#FlippdLaunchList') history.replaceState(null, '', location.pathname + location.search);
    });
    dialog.querySelector('[data-launch-close]').addEventListener('click', close);
    // A tap on the dimmed backdrop (outside the card) closes it.
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });

    // Every launch-list button and link opens the pop-up instead of jumping somewhere.
    document.addEventListener('click', event => {
      const link = event.target.closest && event.target.closest('a[href$="#flippd-launch"]');
      if (!link) return;
      event.preventDefault();
      open();
    }, true);
    window.addEventListener('hashchange', () => { if (location.hash === '#flippd-launch') open(); });

    // After a sign-up the page reloads at #FlippdLaunchList: show the confirmation in the pop-up.
    const status = form && form.querySelector('.flippd-launch-status');
    const justSent = location.hash === '#FlippdLaunchList';
    if (status && !justSent) status.remove();
    if (justSent && form.querySelector('[data-launch-joined]')) store.set(KEY_JOINED, '1');

    if (justSent || location.hash === '#flippd-launch') open();
    else if (!store.get(KEY_JOINED)) {
      const closedAt = Number(store.get(KEY_CLOSED) || 0);
      if (Date.now() - closedAt > SNOOZE_DAYS * 864e5) {
        let fired = false;
        const auto = () => {
          if (fired || document.querySelector('dialog[open]')) return;
          fired = true;
          window.removeEventListener('scroll', onScroll);
          open();
        };
        const onScroll = () => {
          const max = document.documentElement.scrollHeight - innerHeight;
          if (max > 0 && scrollY / max >= SCROLL_SHARE) auto();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        setTimeout(auto, AUTO_OPEN_AFTER);
      }
    }

    // Pincode check, and WhatsApp + pincode saved as customer tags.
    if (!form) return;
    const prefixes = (dialog.dataset.launchPrefixes || '560').split(',').map(p => p.trim()).filter(Boolean);
    const pin = form.querySelector('[data-launch-pincode]');
    const wa = form.querySelector('[data-launch-whatsapp]');
    const tags = form.querySelector('[data-launch-tags]');
    const result = form.querySelector('[data-launch-pin-result]');
    pin.addEventListener('input', () => {
      const code = pin.value.replace(/\D/g, '').slice(0, 6);
      if (pin.value !== code) pin.value = code;
      result.classList.remove('is-in');
      if (code.length < 6) { result.textContent = ''; return; }
      if (prefixes.some(p => code.startsWith(p))) {
        result.textContent = `Good news: we'll deliver to ${code} from launch day.`;
        result.classList.add('is-in');
      } else {
        result.textContent = `We're starting with Bangalore. Join anyway and we'll tell you when we reach ${code}.`;
      }
    });
    form.addEventListener('submit', () => {
      const list = ['bangalore-launch'];
      const code = pin.value.replace(/\D/g, '');
      if (code.length === 6) list.push(`pin-${code}`, prefixes.some(p => code.startsWith(p)) ? 'launch-area' : 'outside-launch-area');
      const phone = wa.value.replace(/\D/g, '').replace(/^0+/, '');
      if (phone.length >= 10) list.push(`wa-${phone.length === 10 ? '91' + phone : phone}`);
      tags.value = list.join(',');
    });
  });
})();
